var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    color: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4276_8285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.87272 6.92185V9.73435M8.87272 12.5469H8.87975M7.89912 3.3301L2.11599 13.3191C1.79523 13.8732 1.63484 14.1502 1.65855 14.3776C1.67922 14.5759 1.78312 14.7561 1.94439 14.8734C2.12928 15.0078 2.44939 15.0078 3.0896 15.0078H14.6558C15.2961 15.0078 15.6162 15.0078 15.8011 14.8734C15.9623 14.7561 16.0662 14.5759 16.0869 14.3776C16.1106 14.1502 15.9502 13.8732 15.6294 13.3191L9.84633 3.33009C9.52671 2.77803 9.3669 2.50199 9.1584 2.40928C8.97653 2.32842 8.76891 2.32842 8.58704 2.40928C8.37855 2.50199 8.21874 2.77803 7.89912 3.3301Z",
    color: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.40625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4276_8285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.875,
    height: 16.875,
    fill: "white",
    transform: "translate(0.4375 0.59375)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.8773dc76e1dd06ab9f6bbb6e2d1251a9.svg";
export { ForwardRef as ReactComponent };